import { PageWrapper } from "../PageWrapper";
import s from "./style.module.scss";
import { data as fallbackData } from "./data";
import { Box, BoxProps } from "./Box";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { useEffect, useState } from "react";
import { getBrandName } from "../../utils/helpers.ts";

interface DynamicBoxData {
  tr_title: string;
  tr_description: string;
  percent: string;
  tr_percent_text: string;
  image: string;
  img_placement: "right" | "left";
  use_video: boolean;
  video_id: string;
  asset_type: string;
  video_url: string;
}

export const TextImageSection = () => {
  const [boxData, setBoxData] = useState<BoxProps[]>(fallbackData);
  const sections = useSectionsData();
  const brandName = getBrandName();

  useEffect(() => {
    try {
      const dynamicData = sections?.pp_v7_text_image_section?.info_blocks || [];

      if (dynamicData && dynamicData.length > 0) {
        const mappedData = dynamicData.map((item: DynamicBoxData) => ({
          title: item.tr_title || "",
          description: item.tr_description || "",
          imagePlacement:
            item.img_placement === "left" || item.img_placement === "right"
              ? item.img_placement
              : "right",
          img: {
            src: item.image || "",
            alt: brandName || "Feature image",
          },
          percents: {
            number: item.percent ? `${item.percent}%` : "0%",
            text: item.tr_percent_text || "",
          },
          isVideo: item.use_video || false,
          assetType: item.asset_type || "iframe",
          r2BucketUrl: item.video_url || "",
          videoId: item.video_id || "",
        }));

        setBoxData(mappedData);
      }
    } catch (error) {
      console.error("Error processing TextImageSection data:", error);
    }
  }, [sections]);

  return (
    <PageWrapper>
      <div className={s.textImageSection}>
        {boxData.map((item, index) => (
          <Box {...item} key={index} />
        ))}
      </div>
    </PageWrapper>
  );
};
